/**
 * @file Writes a decimal amount as exact currency: rounded half away from zero
 * to whole dollars and grouped, such as `"$62,400,000"` or `"-$1,234"`.
 * Consumers: the Overview tiles and tables, and the report run renderers in
 * React and the PDF, which share it so both print the same money from the
 * stored raw decimals. `signed` adds a `+` to a positive amount, for ahead of
 * plan and pace; zero is always `"$0"`. It throws on a string that is not a
 * decimal, so callers verify cells first.
 */
import { analyticsDecimalFraction } from './analyticsDecimalFraction';
import { analyticsFractionDecimal } from './analyticsFractionDecimal';

const GROUPED = new Intl.NumberFormat('en-US');

export const analyticsCurrencyText = (decimal: string, options?: { signed?: boolean }): string => {
  const fraction = analyticsDecimalFraction(decimal);
  if (fraction === undefined) throw new Error(`"${decimal}" is not a decimal.`);
  const dollars = BigInt(analyticsFractionDecimal(fraction, 0));
  const magnitude = GROUPED.format(dollars < 0n ? -dollars : dollars);
  const sign = dollars < 0n ? '-' : options?.signed === true && dollars > 0n ? '+' : '';
  return `${sign}$${magnitude}`;
};
